import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const LogoeditList = Loadable(lazy(() => import('./LogList')));

const LogRoutes = [
	{
		path: '/searchlog',
		element: <LogoeditList />,
		auth: authRoles.admin,
	},
];

export default LogRoutes;
